module.exports = __webpack_public_path__ + "static/media/kids-stroller.6ea1f779.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/experiences/resources/onboardig/svg/kids-stroller.svg
// module id = 3839
// module chunks = 0